import React, { useState } from 'react';
import { CheckSquare, Calendar, Clock, Users, ChevronRight, AlertCircle, PaperclipIcon, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AddTask() {
  const [attachments, setAttachments] = useState<{
    name: string;
    size: string;
  }[]>([]);
  const [selectedCommittee, setSelectedCommittee] = useState('');
  const [selectedAssignee, setSelectedAssignee] = useState('');
  const committees = [{
    id: 1,
    name: 'لجنة المالية'
  }, {
    id: 2,
    name: 'لجنة الموارد البشرية'
  }, {
    id: 3,
    name: 'لجنة تقنية المعلومات'
  }, {
    id: 4,
    name: 'لجنة المشتريات'
  }, {
    id: 5,
    name: 'لجنة ضمان الجودة'
  }];
  const members = [{
    id: 1,
    name: 'محمد الهاشمي',
    committee: 'لجنة المالية'
  }, {
    id: 2,
    name: 'عائشة المنصوري',
    committee: 'لجنة الموارد البشرية'
  }, {
    id: 3,
    name: 'عمر الشامسي',
    committee: 'لجنة تقنية المعلومات'
  }, {
    id: 4,
    name: 'فاطمة الزعابي',
    committee: 'لجنة المشتريات'
  }, {
    id: 5,
    name: 'أحمد الظاهري',
    committee: 'لجنة ضمان الجودة'
  }];
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      if (file) {
        // Convert file size to KB or MB
        const size = file.size > 1024 * 1024 ? `${(file.size / (1024 * 1024)).toFixed(2)} ميجابايت` : `${(file.size / 1024).toFixed(2)} كيلوبايت`;
        setAttachments([...attachments, {
          name: file.name,
          size
        }]);
      }
    }
  };
  const removeAttachment = (index: number) => {
    const newAttachments = [...attachments];
    newAttachments.splice(index, 1);
    setAttachments(newAttachments);
  };
  const filteredMembers = selectedCommittee ? members.filter(member => member.committee === selectedCommittee) : members;
  return <div dir="rtl" data-id="element-1899">
      <div className="flex items-center mb-6" data-id="element-1900">
        <Link to="/tasks" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-1901">
          <ChevronRight size={20} className="ml-1" data-id="element-1902" />
          العودة إلى المهام
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1903">إضافة مهمة جديدة</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1904">
        <form data-id="element-1905">
          <div className="space-y-6" data-id="element-1906">
            {/* Task Title */}
            <div data-id="element-1907">
              <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1908">
                عنوان المهمة <span className="text-red-500" data-id="element-1909">*</span>
              </label>
              <input type="text" id="title" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="أدخل عنوان المهمة" required data-id="element-1910" />
            </div>
            {/* Task Description */}
            <div data-id="element-1911">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1912">
                الوصف <span className="text-red-500" data-id="element-1913">*</span>
              </label>
              <textarea id="description" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="أدخل وصف المهمة" required data-id="element-1914"></textarea>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1915">
              {/* Committee */}
              <div data-id="element-1916">
                <label htmlFor="committee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1917">
                  اللجنة <span className="text-red-500" data-id="element-1918">*</span>
                </label>
                <div className="relative" data-id="element-1919">
                  <select id="committee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" required value={selectedCommittee} onChange={e => setSelectedCommittee(e.target.value)} data-id="element-1920">
                    <option value="" data-id="element-1921">اختر اللجنة</option>
                    {committees.map(committee => <option key={committee.id} value={committee.name} data-id="element-1922">
                        {committee.name}
                      </option>)}
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1923">
                    <Users size={18} className="text-gray-400" data-id="element-1924" />
                  </div>
                </div>
              </div>
              {/* Assigned To */}
              <div data-id="element-1925">
                <label htmlFor="assignee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1926">
                  تعيين إلى <span className="text-red-500" data-id="element-1927">*</span>
                </label>
                <div className="relative" data-id="element-1928">
                  <select id="assignee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" required value={selectedAssignee} onChange={e => setSelectedAssignee(e.target.value)} data-id="element-1929">
                    <option value="" data-id="element-1930">اختر المكلف</option>
                    {filteredMembers.map(member => <option key={member.id} value={member.name} data-id="element-1931">
                        {member.name}
                      </option>)}
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1932">
                    <Users size={18} className="text-gray-400" data-id="element-1933" />
                  </div>
                </div>
              </div>
              {/* Deadline */}
              <div data-id="element-1934">
                <label htmlFor="deadline" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1935">
                  تاريخ الاستحقاق <span className="text-red-500" data-id="element-1936">*</span>
                </label>
                <div className="relative" data-id="element-1937">
                  <input type="date" id="deadline" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" required data-id="element-1938" />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1939">
                    <Calendar size={18} className="text-gray-400" data-id="element-1940" />
                  </div>
                </div>
              </div>
              {/* Priority */}
              <div data-id="element-1941">
                <label htmlFor="priority" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1942">
                  الأولوية <span className="text-red-500" data-id="element-1943">*</span>
                </label>
                <div className="relative" data-id="element-1944">
                  <select id="priority" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" required data-id="element-1945">
                    <option value="" data-id="element-1946">اختر الأولوية</option>
                    <option value="high" data-id="element-1947">عالية</option>
                    <option value="medium" data-id="element-1948">متوسطة</option>
                    <option value="low" data-id="element-1949">منخفضة</option>
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1950">
                    <AlertCircle size={18} className="text-gray-400" data-id="element-1951" />
                  </div>
                </div>
              </div>
            </div>
            {/* Attachments */}
            <div data-id="element-1952">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1953">
                المرفقات
              </label>
              <div className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center" data-id="element-1954">
                <div className="mb-3" data-id="element-1955">
                  <PaperclipIcon size={24} className="mx-auto text-gray-400" data-id="element-1956" />
                </div>
                <p className="text-sm text-gray-500 mb-2" data-id="element-1957">
                  اسحب وأفلت الملفات هنا، أو انقر للتصفح
                </p>
                <p className="text-xs text-gray-400 mb-3" data-id="element-1958">
                  الصيغ المدعومة: PDF، DOCX، XLSX، PPTX (الحد الأقصى 10
                  ميجابايت)
                </p>
                <input type="file" id="file-upload" className="hidden" onChange={handleFileUpload} data-id="element-1959" />
                <label htmlFor="file-upload" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors cursor-pointer" data-id="element-1960">
                  تصفح الملفات
                </label>
              </div>
              {/* Attachment List */}
              {attachments.length > 0 && <div className="mt-4 space-y-2" data-id="element-1961">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1962">
                    الملفات المرفوعة
                  </h4>
                  {attachments.map((file, index) => <div key={index} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-1963">
                      <div className="flex items-center" data-id="element-1964">
                        <PaperclipIcon size={16} className="text-gray-500 ml-2" data-id="element-1965" />
                        <span className="text-sm font-medium" data-id="element-1966">{file.name}</span>
                        <span className="mr-2 text-xs text-gray-500" data-id="element-1967">
                          {file.size}
                        </span>
                      </div>
                      <button type="button" onClick={() => removeAttachment(index)} className="text-gray-400 hover:text-red-500" data-id="element-1968">
                        <X size={16} data-id="element-1969" />
                      </button>
                    </div>)}
                </div>}
            </div>
            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-4" data-id="element-1970">
              <Link to="/tasks" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors mr-3" data-id="element-1971">
                إلغاء
              </Link>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1972">
                <CheckSquare size={18} className="inline ml-2" data-id="element-1973" />
                إنشاء المهمة
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}